import { App } from '../../../App';
import { DEFAULT_AMOUNT, DEFAULT_TERM } from '../../../utils/constants';
import { getFetchHeaders } from '../../../utils/fetchHeaders';
import { useErrorManager } from '../../../InternalLibrary';
import { useGetLegalTerms } from '../../../api';
import { useTranslation } from 'react-i18next';
import Modal from 'components/molecules/Modal/Modal';
import React, { memo, PropsWithChildren, useEffect, useState } from 'react';
import styles from './LegalTermsModal.module.scss';
import useApplication from '../../../hooks/useApplication';
import useClient from '../../../hooks/useClient';

export type Props = {
  amount?: number;
  term?: number;
  onClose: () => void;
};

export default memo(function LegalTermsModal({
  amount,
  term,
  onClose,
}: PropsWithChildren<Props>) {
  const { t } = useTranslation('registration_header');
  const { client } = useClient();
  const { setError } = useErrorManager();
  const apiLegalTerms = useGetLegalTerms();
  const { data: application } = useApplication();
  const [content, setContent] = useState<string | undefined>(undefined);

  const amountParam = String(amount || application?.amount || DEFAULT_AMOUNT);
  const termParam = String(term || application?.term || DEFAULT_TERM);

  const handleLegalContent = async () => {
    try {
      const data = await apiLegalTerms.fetch({
        headers: getFetchHeaders({
          Accept: 'text/html',
          'Content-Type': 'text/html',
        }),
        queryParameters: {
          attachment: false,
          amount: String(amountParam),
          term: Number(termParam),
          productNumber: client?.productNumber || App.config.productNumber,
        },
      });
      setContent(data as string);
    } catch (e) {
      setError(e);
    }
  };

  useEffect(() => {
    handleLegalContent();
  }, [amount, term, application?.amount, application?.term]);

  return (
    <Modal
      className={styles.modal}
      isOpen
      onClose={onClose}
      title={t('title_modal')}
    >
      {content && <div dangerouslySetInnerHTML={{ __html: content }}></div>}
    </Modal>
  );
});
